module.exports = __webpack_public_path__ + "img/Blog-Image.b9511532.png";